export default __webpack_public_path__ + "static/media/liability-mobile.07552b06.png";